<template>
  <div class="widget">
    <div class="op">
      <div class="title">{{ $t('pages_home_fx_001') }}</div>
      <div class="info">
        <div class="desc">{{ $t('pages_home_fx_003') + ' ' + priceUpdateTime }}</div>
        <div>
          <circle-progress :timeSecondsCounter="timeSecondsCounter" :totalTime="totalTime" />
        </div>
      </div>
    </div>
    <div class="fx-area">
      <div v-if="Object.keys(priceMap).length === 0" class="empty">
        <a-spin />
      </div>
      <div v-else>
        <div class="fx-row" v-for="(price, key) in priceMap" :key="key">
          <div class="fx-item">
            <div class="fx-title">{{ key }}</div>
            <div class="fx-price">{{ price }}</div>
          </div>
        </div>
        <div>
          <a @click="fxNav">{{ $t('pages_home_fx_002') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onUnmounted, defineComponent, ref } from 'vue'
import CircleProgress from '@/components/circle-progress'
// import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { _exchange } from '@/api'
export default defineComponent({
  name: 'Fx',
  components: {
    'circle-progress': CircleProgress
  },
  setup() {
    const router = useRouter()
    let timer = null
    const totalTime = 60
    const timeSecondsCounter = ref(totalTime)
    const priceLoading = ref(false)
    const priceUpdateTime = ref(new Date().toTimeString().substr(0, 8))
    const priceMap = ref({})
    const pairs = ref([])
    // const store = useStore()
    onUnmounted(() => {
      clearInterval(timer)
    })

    const init = async () => {
      // store.dispatch('getCurList')
      console.log('init')
      await loadPairs()
      loadFxPrices()
    }

    const loadPairs = async () => {
      console.log('loadPairs')
      const res = await _exchange.getSupRateCur({
        lockRateType: '00'
      })
      if (res.data.succ) {
        const { supList } = res.data.data
        // Load 3 USD pairs
        pairs.value = supList
          .filter(item => item.sellCurrency === 'USD')
          .slice(0, 3)
          .map(item => item.sellCurrency + '/' + item.buyCurrency)
        console.log('pairs:', pairs)
      }
    }

    const loadFxPrices = async () => {
      console.log('loadFxPrices')
      priceLoading.value = true
      const res = await _exchange.getExchangeRates({ pairs: pairs.value })
      if (res.data.succ) {
        // state.totalAmount = parseMoney(res.data.data)
        priceLoading.value = false
        // to HH:mm:ss
        priceUpdateTime.value = new Date().toTimeString().substr(0, 8)
        priceMap.value = res.data.data.ratesMap
      }

      clearInterval(timer)
      timer = setInterval(() => {
        if (timeSecondsCounter.value > 0) {
          timeSecondsCounter.value--
        } else {
          timeSecondsCounter.value = totalTime
          loadFxPrices()
        }
      }, 1000)
    }

    const fxNav = () => {
      router.push('/exchange/apply')
    }

    init()

    return {
      priceLoading,
      timeSecondsCounter,
      totalTime,
      priceUpdateTime,
      priceMap,
      fxNav
    }
  }
})
</script>

<style lang="less" scoped>
.fx-area {
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  border: solid 1px #E5E9F2;
  margin-top: 20px;
  padding: 0 20px;
  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .ant-empty {
      margin-top: 0;
    }
  }
  .fx-row {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 20px 10px;
    .fx-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      // round rect background with color
      background: #F0F5FF;
      border-radius: 5px;
      padding: 10px;
      .fx-title {
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }
      .fx-price {
        color: #333;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
.op {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    .desc {
      color: #858b99;
      font-size: 14px;
    }
  }
}
</style>
